module.exports = __webpack_public_path__ + "img/Bg.4185ea33.png";